// Rutas con puntos para nombrar una clave del guion.
//
// ESPEJO de omnibot-platform/tenant/ruta.go. Las dos tienen que escapar igual:
// el servidor guarda con esas claves y el navegador las construye para pedir un
// cambio, así que una discrepancia manda el texto a otro sitio del guion — sin
// error, con el guion válido, y el cliente siguiendo con el mensaje viejo.
//
// Por qué hace falta escapar: un punto separa niveles, pero los nombres de
// mensaje pueden llevar punto — la consola bautiza los que traen las
// capacidades como `<capacidad>.<rol>`. Sin distinguirlos,
// "plantillas.consultar_cartera.ok" significa dos cosas a la vez.
//
//	plantillas.menu_principal          plantillas > menu_principal
//	plantillas.consultar_cartera\.ok   plantillas > consultar_cartera.ok

function escapar(s: string): string {
  return s.replace(/\\/g, '\\\\').replace(/\./g, '\\.')
}

/** Une segmentos en una ruta, escapando lo que haga falta. */
export function ruta(...segmentos: string[]): string {
  return segmentos.map(escapar).join('.')
}

/** Deshace `ruta`: devuelve los nombres tal como son, sin escapes. */
export function segmentos(r: string): string[] {
  if (!r) return []
  const out: string[] = []
  let actual = ''
  let escapando = false
  for (const c of r) {
    if (escapando) { actual += c; escapando = false; continue }
    if (c === '\\') { escapando = true; continue }
    if (c === '.') { out.push(actual); actual = ''; continue }
    actual += c
  }
  // Una barra suelta al final se toma como literal en vez de perderse: perder
  // un carácter en silencio es peor que un nombre raro.
  if (escapando) actual += '\\'
  out.push(actual)
  return out
}

/** El último segmento — el nombre a secas. Para "plantillas.saludo", "saludo". */
export function nombreDe(r: string): string {
  const s = segmentos(r)
  return s[s.length - 1] ?? ''
}
